// extracted by mini-css-extract-plugin
module.exports = {"ldsRoller":"Spinner_ldsRoller__T1F5i"};